// The last few script errors and error messages on this page, kept in memory
// only, for "Report a bug" (see bugReport.ts). No imports, so the store can
// use it without a cycle.

const KEEP = 10;
const log: string[] = [];

function remember(line: string): void {
  log.push(`${new Date().toISOString().slice(11, 19)} ${line.slice(0, 1000)}`);
  if (log.length > KEEP) log.shift();
}

/** Start keeping the last few uncaught errors (main.tsx calls this once). */
export function installErrorLog(): void {
  window.addEventListener('error', (e) => {
    const where = e.filename ? ` (${e.filename.split('/').pop()}:${e.lineno}:${e.colno})` : '';
    remember(`error: ${e.message || String(e.error)}${where}`);
  });
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason as { message?: string; stack?: string } | undefined;
    remember(`unhandled rejection: ${r?.message ?? String(e.reason)}`);
  });
}

/** Error toasts the person saw ("Import failed: …") are often the best clue. */
export function noteErrorMessage(text: string): void {
  remember(`shown to the user: ${text}`);
}

export function recentErrors(): string[] {
  return [...log];
}
